<template>
  <v-row>
    <v-col sm="6" >
      <v-form v-on:submit.prevent="submitForm()" v-model="valid" ref="form" enctype="multipart/form-data">
        <v-card flat :border="true">
          <v-card-text>
            <v-text-field
              :label="t('brand')"
              v-model="vehicleType.brand"
              required
              variant="underlined"
            ></v-text-field>

            <v-text-field
              :label="t('model')"
              v-model="vehicleType.model"
              required
              variant="underlined"
            ></v-text-field>

            <v-select
              :label="t('type')"
              v-model="vehicleType.name"
              :items="vehicleTypeNameOptions"
              item-title="title"
              item-value="value"
              required
              variant="underlined"
            ></v-select>

            <v-file-input
              accept="image/*"
              clearable
              flat
              variant="underlined"
              prepend-icon="mdi-file-image"
              :label="t('image')"
              @change="onImageChange"
            />

            <img v-if="vehicleType.image_url" :src="vehicleType.image_url" class="preview" />
          </v-card-text>
          <v-card-actions>
            <v-btn color="orange-darken-2" depressed type="submit" v-show="!loading" :disabled="!valid">
              {{ buttonText }}
            </v-btn>
            <v-progress-circular indeterminate color="orange-darken-2" v-show="loading"></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVehicleTypeNames } from '@/utils/vehicleTypeNames'

const props = defineProps({
  vehicleType: {
    type: Object,
    required: true
  },
  submit: {
    type: Function,
    required: true
  },
  onInput: {
    type: Function,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  buttonText: {
    type: String,
    default: 'Save'
  }
})

const { t } = useI18n()
const { vehicleTypeNameOptions } = useVehicleTypeNames()

const valid = ref(false)
const form = ref()
const imageFile = ref(null as File | null)

const onImageChange = (event: any) => {
  imageFile.value = event.target.files[0] || null
}

const submitForm = () => {
  props.submit(imageFile.value)
}
</script>

<style scoped lang="scss">
.preview {
  height: 96px;
  width: auto;
  clear: both;
}
</style>
